import { createDomain } from 'effector-root';

const domain = createDomain('ForgotPassword (Page)');

export const onPageStarted = domain.event();